import 'regenerator-runtime/runtime'
// @it-enterprise пакеты
//import Localization from '@it-enterprise/localization'

import * as ellipsed from 'ellipsed'
// vue пакеты
import Vue from 'vue'
import Vuex from 'vuex'
import store from './store/index'
import vuetify from './plugins/vuetify'
import { i18n } from './plugins/i18n'
import router from './router'
import $auth from './plugins/authPlugin'
import acl from './acl/acl'
import { abilitiesPlugin } from '@casl/vue'
import ability from './acl/ability'
import MaskedInput from 'vue-masked-input'

import * as Sentry from '@sentry/vue'
import { ExtraErrorData, Dedupe, HttpClient } from '@sentry/integrations'

import './scss/main.scss'
import App from './App.vue'

import VueCookies from 'vue-cookies'
import lodash from 'lodash'
import VueApexCharts from 'vue-apexcharts'
import VueDOMPurifyHTML from 'vue-dompurify-html'

import Toolkit from './toolkit/index.js'

import globalMixin from 'mixins/globalMixin.js'
import { formatPrice, formatBidPrice } from 'utils/formatPrice.js'

import moment from 'moment'
// Єдина локаль moment у бандлі (інші відкидає IgnorePlugin у vue.config.js; en вбудована в ядро).
// Імпорт робить uk локаллю за замовчуванням: мова без локалі в бандлі лишить uk, а не англійську
import 'moment/locale/uk'
moment.locale(sessionStorage.language)
// Плагины стандартные
Vue.use(Vuex)
Vue.use(Toolkit)
Vue.use(abilitiesPlugin, ability)

const $notifier = require('./plugins/notifyPlugin').default

Vue.prototype.$log = function(...m) {
  store.dispatch('storeWarn', { values: m })
  if (window.config?.node_env !== 'production') {
    console.debug(...m) // eslint-disable-line no-console
  }
}

Vue.use($notifier)
Vue.use($auth)
Vue.use(VueCookies)
Vue.use(VueApexCharts)
Vue.use(VueDOMPurifyHTML, {
  namedConfigurations: {
    'svg': {
      USE_PROFILES: { svg: true }
    },
    'mathml': {
      USE_PROFILES: { mathMl: true }
    },
  },
  default: {
    ADD_ATTR: [
      'mode', 'type', 'class',
      'props_tender', 'props_offer' // разрешить props_*
    ]
  }
})

Vue.prototype.$store = store
Vue.prototype.$moment = moment

// Глобальные хелперы для форматирования цен
Vue.prototype.$formatPrice = formatPrice
Vue.prototype.$formatBidPrice = formatBidPrice

Vue.directive('scroll', {
  inserted (el, binding) {
    let f = function (evt) {
      if (binding.value(evt, el)) {
        Vue.prototype.$log('remove listener')
        window.removeEventListener('scroll', f)
      }
    }
    Vue.prototype.$log('add listener')
    window.addEventListener('scroll', f)
  }
})
Vue.directive('resize', {
  inserted: function(el, binding) {
    const onResizeCallback = binding.value
    // Глобальный обработчик resize через eventBus с троттлом
    let lastEmit = 0
    const throttle = 1000 // 1 секунда
    let lastWidth = document.documentElement.clientWidth
    let lastHeight = document.documentElement.clientHeight
    const resizeHandler = () => {
      const width = document.documentElement.clientWidth
      const height = document.documentElement.clientHeight
      if (width !== lastWidth || height !== lastHeight) {
        onResizeCallback({ width, height })
        const now = Date.now()
        if (now - lastEmit > throttle) {
          eventBus.$emit('resizeWindow', { width, height })
          lastEmit = now
        }
        lastWidth = width
        lastHeight = height
      }
    }
    window.addEventListener('resize', resizeHandler)
    el._resizeHandler = resizeHandler
  },
  unbind: function(el) {
    if (el._resizeHandler) {
      window.removeEventListener('resize', el._resizeHandler)
      delete el._resizeHandler
    }
  }
})
/*eslint-disable */

Vue.config.productionTip = window.config?.node_env === 'production'
Vue.config.devtools = window.config?.node_env !== 'production'
Vue.config.performance = window.config?.node_env !== 'production'

if (window.config?.node_env === 'production') {
  Vue.config.errorHandler = function(err, vm, info) {
    store.dispatch('storeError', `Error: ${err?.toString()}\nInfo: ${info}`)
  }
  Vue.config.warnHandler = function(msg, vm, trace) {
    store.dispatch('storeWarn', `Warn: ${msg}\nTrace: ${trace}`)
  }

  window.onerror = function(message, source, line, column, error) {
    store.dispatch('storeError', `Error: ${message}\nSource: ${source}:${line}:${column}\nTrace: ${error}`)
  }
  // window.addEventListener('error', (event) => {
  //   console.error(`${event.type}: ${event.message}`)
  //   store.dispatch('storeError', `${event.type}: ${event.message}`)
  // },{capture: true, passive: true})

  window.addEventListener('unhandledrejection', function(event) {
    store.dispatch('storeError', event?.reason?.stack?.toString())
  },{capture: true, passive: true})

  window.addEventListener('uncaughtException', function(event) {
    store.dispatch('storeError', event?.reason?.stack?.toString())
  },{capture: true, passive: true})
}
const version = require('../package.json').version

if (window.config?.NODE_ENV !== 'development') {
  Sentry.init({
    Vue,
    enabled: window.config?.node_env !== 'development',// тут можно отключить
    dsn: window.config?.SentryDSN,
    logErrors: true, //window.config?.node_env !== 'production',
    release: `${version}.${window.config?.BuildVersion}`,
    debug: false,
    trackComponents: true,
    //autoSessionTracking: true,
    autoSessionTracking: false,
    environment: window.config?.node_env,
    hooks: ["mount", "update", "destroy"],
    sendDefaultPii: true, // This option is required for capturing headers and cookies.
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 0.1,
    integrations: [
      new ExtraErrorData(),
      // CaptureConsole removed — console.error floods Sentry with noise (e.g. oidc-client network errors)
      new Dedupe(), // Убирает повторы
      new HttpClient({
        failedRequestStatusCodes: [[400, 404], [500, 505], 507]
      }),
      //new Sentry.Integrations.GraphQL(),
      new Sentry.BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      }),
      new Sentry.BrowserProfilingIntegration(),
    ],
    tracesSampleRate: window.config?.node_env == 'production' ? 0.01 : 1.0, // Capture 100% of the transactions, reduce in production!
    replaysSessionSampleRate: window.config?.node_env == 'production' ? 0.01 : 1.0, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: window.config?.node_env == 'production' ? 1.0 : 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.

    beforeSend(event, hint) {
      // Фильтрация дублей и неинформативных ошибок
      if (event.fingerprint && event.fingerprint.length) {
        if (window._sentryFingerprints && window._sentryFingerprints.includes(event.fingerprint.join('-'))) {
          return null
        }
        window._sentryFingerprints = window._sentryFingerprints || []
        window._sentryFingerprints.push(event.fingerprint.join('-'))
      }
      /** не логируем события от пользователей с ролями disableLogRoles*/
      const disableLogRoles = [/*'QA', 'ADMIN', 'FRONTOFFICEEMPLOYEE', 'FRONTOFFICEADMIN'*/]
      const getUserRoles = event.extra?.userProfile?.tenderSettings?.accessRole

      if (getUserRoles && disableLogRoles.some(role => getUserRoles.includes(role))) {
        return null
      }
     
      const ignoredErrorPatterns = [
        /HTTP Client Error with status code: (401|403|404|409)/,
        'Hub disconnected',
        'login_required',
        'WebSocket closed with status code: 1006',
        'Network error: Failed to fetch',
        'JsonService.getJson: network error',
      ];
      const shouldIgnore = event?.message && ignoredErrorPatterns.some(pattern => {
        if (typeof pattern === 'string') {
          return event.message.includes(pattern);
        }
        return pattern.test(event.message);
      });

      if (shouldIgnore) {
        return null
      }
      return event
    },
  });

  Vue.prototype.$sentry = Sentry
}

Vue.mixin(globalMixin);

// Шина событий
export const eventBus = new Vue({
  router,
  acl,
  vuetify,
  i18n,
  $auth,
  $notifier,
  store,
  render: h => h(App),
  renderError (h, err) {
    return  h('pre', { style: { color: 'red' }}, err.stack)
  }
}).$mount('#app')


Vue.component('apexchart', VueApexCharts)
// импорт компонентов
const req = require.context('@/public/', true, /\.(js|vue)$/i)
req.keys().map(key => {
  if (!(req(key).default || {}).name) {
    return
  }
  Vue.component(req(key).default.name, req(key).default)
})

Vue.component('masked-input' , MaskedInput)

/*eslint-disable */

// Общая функция для стилизованного вывода в консоль
function styledConsoleLog(icon, backgroundColor, message) {
  const hasObjects = message.some(m => typeof m === 'object' && m !== null);
  const style = `background: ${backgroundColor}; color: #908874; font-weight: bold; padding: 2px 6px; border-radius: 3px;`;
  
  if (hasObjects) {
    console.groupCollapsed(`%c${icon} s.smarttender.log`, style);
    message.forEach(m => console.debug(m));
    console.groupEnd();
  } else {
    console.debug(`%c${icon} s.smarttender.log`, style, ...message);
  }
}

Vue.prototype.$sinfo = function(...message) {
  let force = false;
  // Проверяем последний аргумент. Если это объект с флагом, то используем его и убираем из массива.
  const lastArg = message[message.length - 1];
  if (typeof lastArg === 'object' && lastArg !== null && lastArg.force === true) {
    force = true;
    message.pop();
  }

  if (window.config?.node_env != 'production' || force || localStorage.getItem('showServiceMessage')) {
    styledConsoleLog('ℹ️', '#c9e5fcff', message);
  }
}
Vue.prototype.$swarn= function(...message) {
  if (window.config?.node_env != 'production' || localStorage.getItem('showServiceMessage')) {
    styledConsoleLog('⚠️', '#fcebc9ff', message);
  }
}
Vue.prototype.$serror = function(...message) {
  if (window.config?.node_env != 'production' || localStorage.getItem('showServiceMessage')) {
    styledConsoleLog('❌', 'rgba(253, 178, 188, 1)', message);
  }
}
Vue.prototype.$time = function(label) {
  if (window.config?.node_env === 'development') return
  console.time(label)
}
Vue.prototype.$timeEnd = function(label) {
  if (window.config?.node_env === 'development') return
  console.timeEnd(label)
}
Vue.prototype.$ellipsed = ellipsed
Vue.prototype.$_ = lodash

Vue.prototype.$log_info = function(...m) {
  if (window.config?.node_env === 'production') {
    store.dispatch('storeInfo', { values: m })
  }
}
/** Что б хоть как-то видеть ошибки. Иначе, при тестировании очень многоч его пропускаем */
Vue.prototype.$log_error = function(...m) {
  if (window.config?.node_env !== 'development') {
    Sentry.captureMessage(...m)
  }
  if (window.config?.node_env === 'production') {
    store.dispatch('storeError', { values: m })
  }
  console.error(...m)
}
Vue.prototype.$log_warn = function(...m) {
  store.dispatch('storeWarn', `Warn: ${m}`)
  console.warn(...m)
}
Vue.prototype.$show_error_message = function(m) {
  if (window.config?.node_env !== 'development') {
    Sentry.captureMessage(m)
  }
  eventBus.$emit('showErrorSnackbar', m)
}
Vue.prototype.$assert = function(...m) {
  console.assert(...m)
}
/*eslint-disable */
